/* Common Variables */
export const ENV_KEYS = new Set(['local', 'stage', 'dev1', 'dev2', 'dev3', 'dev4', 'production']);

export const BAN_VPN_URLS = {
  production: 'https://ban-vpn.zvuk-b2b.com',
  stage: 'https://ban-vpn-stage.zvuk-b2b.com',
  dev1: 'https://ban-vpn-dev-1.zvuk-b2b.com',
  dev2: 'https://ban-vpn-dev-2.zvuk-b2b.com',
  dev3: 'https://ban-vpn-dev-3.zvuk-b2b.com',
  dev4: 'https://ban-vpn-dev-4.zvuk-b2b.com',
  local: 'https://ban-vpn-stage.zvuk-b2b.com',
} as const;

export const BACKEND_ENV = 'production' as keyof typeof BAN_VPN_URLS;

/* Common Vite Variables */
export const BASE_URL = import.meta.env.BASE_URL;
export const MODE = import.meta.env.MODE;
export const DEV = import.meta.env.DEV;
export const PROD = import.meta.env.PROD;

/* Sensitive Data, access only throw Vite */
export const ZVUK_API_GRAPHQL_URL = import.meta.env.ZVUK_API_GRAPHQL_URL;
export const ZVUK_AMP_API_KEY = import.meta.env.ZVUK_AMP_API_KEY;
export const ZVUK_CAPCHA_API_KEY = import.meta.env.ZVUK_CAPCHA_API_KEY;
export const ZVUK_DEV_PROXY_TARGET = import.meta.env.ZVUK_DEV_PROXY_TARGET;

export const ZVUK_GTM_KEY = import.meta.env.ZVUK_GTM_KEY;
export const ZVUK_GTM_TEST_KEY = import.meta.env.ZVUK_GTM_TEST_KEY;
export const ZVUK_ALICE_AUTH_SERVER_URI = import.meta.env.ZVUK_ALICE_AUTH_SERVER_URI;

const process = window.process;

/* Non sensitive Common Data */
export const ZVUK_ENV = process && process.env ? process.env.ENV : import.meta.env.ZVUK_ENV;
export const ZVUK_SENTRY_ENV = process && process.env ? process.env.SENTRY_ENV : import.meta.env.ZVUK_SENTRY_ENV;
export const ZVUK_ANALYTIC_ENV = process && process.env ? process.env.ANALYTIC_ENV : import.meta.env.ZVUK_ANALYTIC_ENV;
export const ZVUK_DEV_ALLOWED_HOST =
  process && process.env ? process.env.DEV_ALLOWED_HOST : import.meta.env.ZVUK_DEV_ALLOWED_HOST;

export const CDN_URL =
  (process && process.env ? process?.env?.CDN_URL : import.meta.env.CDN_URL) || 'https://f.stage.muzlab.ru/';

export const ZVUK_REALTIME_BFF_URL =
  process && process.env ? process.env.REALTIME_BFF_URL : import.meta.env.ZVUK_REALTIME_BFF_URL;

/* Non sensitive Feature Flags */
export const ZVUK_FEATURE_PHONE_AUTH_AVAILABLE =
  process && process.env ? process.env.FEATURE_PHONE_AUTH_AVAILABLE : import.meta.env.ZVUK_FEATURE_PHONE_AUTH_AVAILABLE;

export const ZVUK_WITH_BROADCAST_SCHEDULE =
  process && process.env ? process.env.WITH_BROADCAST_SCHEDULE : import.meta.env.ZVUK_WITH_BROADCAST_SCHEDULE;

export const ZVUK_FEATURE_SHELF_PAGE =
  process && process.env ? process.env.FEATURE_SHELF_PAGE : import.meta.env.ZVUK_FEATURE_SHELF_PAGE;

export const ZVUK_FEATURE_SUB_COLLECTIONS =
  process && process.env ? process.env.FEATURE_SUB_COLLECTIONS : import.meta.env.ZVUK_FEATURE_SUB_COLLECTIONS;

export const ZVUK_SHOW_CAPTCHA = process && process.env ? process.env.SHOW_CAPTCHA : import.meta.env.ZVUK_SHOW_CAPTCHA;

export const ZVUK_SHOW_CONTACT_WITH_MANAGER_BUTTON =
  process && process.env
    ? process.env.SHOW_CONTACT_WITH_MANAGER_BUTTON
    : import.meta.env.ZVUK_SHOW_CONTACT_WITH_MANAGER_BUTTON;

export const ZVUK_NEW_POINT_AD_LIST =
  process && process.env ? process.env.NEW_POINT_AD_LIST : import.meta.env.ZVUK_NEW_POINT_AD_LIST;
